<template>
    <v-dialog v-model="dialog" width="1000" persistent scrollable class="overflow-hidden">
        <template v-slot:activator="{ on, attrs }">
            <v-badge color="error" dot v-model="showBadge">
                <span v-on="on" v-bind="attrs" class="ml-4">
                    V {{ latestChangelog ? latestChangelog.version : '...' }}
                </span>
            </v-badge>
        </template>

        <v-card>
            <v-toolbar flat dark color="primary">
                <v-toolbar-title>Changelogs</v-toolbar-title>
            </v-toolbar>

            <v-spacer></v-spacer>
            <div class="d-flex ma-4">
                <v-select
                    :items="changelogs"
                    label="Version"
                    v-model="selectedChangelog"
                    filled
                    :item-value="changelog"
                >
                    <template slot="selection" slot-scope="data">
                        Versie {{ data.item.version.toString() }} | {{ data.item.created_at | formattedDate }}
                    </template>
                    <template slot="item" slot-scope="data" v-if="selectedChangelog">
                        Versie {{ data.item.version.toString() }} | {{ data.item.created_at | formattedDate }}
                    </template>
                </v-select>

                <v-spacer></v-spacer>

                <div class="d-flex flex-column">
                    <can perform="create" :on="changelogClass">
                        <Create />
                    </can>
                    <can v-if="selectedChangelog" perform="delete" :on="selectedChangelog">
                        <event-button :event="destroy"
                                      confirm-message="Weet je zeker dat je deze changelog wilt verwijderen?"
                                      color="error"
                        >
                            <v-icon small class="mr-2">mdi-trash-can</v-icon>
                            Verwijder Changelog
                        </event-button>
                    </can>
                </div>
            </div>

            <v-card flat outlined class="ma-2">
                <v-card-text class="text-body-1" v-if="selectedChangelog" v-html="selectedChangelog.content">
                </v-card-text>
            </v-card>

            <v-card-actions>
                <v-btn color="primary" @click="close">Sluiten</v-btn>
                <v-spacer></v-spacer>
                <can v-if="selectedChangelog" perform="update" :on="selectedChangelog">
                    <Edit :id="selectedChangelog.id" @changelogChanged="setChangelogAfterUpdate" />
                </can>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Changelog from "@/models/Changelog/Changelog";
import User from "@/models/User/User";
import Create from "@/components/Changelog/Create.vue";
import Edit from "@/components/Changelog/Edit.vue";
import EventButton from "@/components/General/Button/EventButton.vue";
import moment from "moment/moment";
import Can from "@/components/General/Policy/Can.vue";

export default {
    components: {
        Can,
        EventButton,
        Create,
        Edit,
    },
    data() {
        return {
            changelogClass: new Changelog(),
            changelog: null,
            dialog: false,
            loading: false,
            showBadge: false,
            selectedChangelog: null,
        }
    },
    watch: {
        latestChangelog(value) {
            if (!this.selectedChangelog) {
                this.selectedChangelog = value;
            }

            if (value !== null) {
                this.setShowBadge();
            }
        },
        dialog(open) {
            if (open) {
                this.setChangelogSeenByUser();
                this.setShowBadge();
            }
            if (!open) {
                this.setShowBadge();
            }
        }
    },
    computed: {
        changelogs() {
            return Changelog.query().orderBy('id', 'desc').get();
        },
        currentChangelog() {
            return this.changelogs.find(changelog => changelog.id === this.selectedChangelog.id);
        },
        latestChangelog() {
            if (this.changelogs.length > 0) {
                return this.changelogs[0];
            }

            return null;
        },
        currentUser() {
            return User.loggedInUser();
        },
    },
    methods: {
        async setChangelogAfterUpdate() {
            await this.fetchChangelogs();
            this.selectedChangelog = this.currentChangelog;
        },
         async fetchChangelogs() {
            this.loading = true;
            Changelog.query().deleteAll();

           await Changelog.api().get(true).then(() => {
                this.setShowBadge();
                this.loading = false;
            });
        },
        setChangelogSeenByUser() {
            User.api().updateById(this.currentUser.id, {
                changelog_last_seen_at: moment().format('YYYY-MM-DD HH:mm:ss'),
            });
        },
        setShowBadge() {
            if (this.changelogs.length > 0) {
                if (moment(this.latestChangelog.created_at).diff(this.currentUser.changelog_last_seen_at) > 0) {
                    this.showBadge = true;
                } else {
                    this.showBadge = false;
                }
            }
        },
        destroy() {
            return Changelog.api().deleteById(this.selectedChangelog.id).then(() => {
                this.fetchChangelogs();
                this.selectedChangelog = this.latestChangelog ? this.latestChangelog : null;
            });
        },
        close() {
            this.fetchChangelogs();
            this.dialog = false;
        }
    },
    created() {
        this.selectedChangelog = this.latestChangelog;
        this.fetchChangelogs();
    }
}
</script>
